import { array } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Billing, Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface Args {
	model: Billing.ServiceInfo | Billing.Addon;
}

export default class AccountBillingSummaryRowComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;

	get rowClass() {
		return `account-billing-summary-row--${this.isService ? 'service' : 'addon'}`;
	}

	get isService() {
		return (this.args.model as Billing.ServiceInfo).isPurchasable !== undefined;
	}

	get priceFormatted() {
		let priceFormatted;
		if (this.isService) {
			const model = this.args.model as Billing.ServiceInfo;
			if (model.price) {
				priceFormatted = `<span>${model.priceFormatted}</span> (one time payment)`;
			}
		} else {
			const activePlan = this.billingService.activePlan,
				billingCycle = activePlan?.billingCycle,
				price = billingCycle
					? (this.args.model as Billing.Addon).prices[billingCycle]
					: null;

			priceFormatted = `<span>${price?.priceFormatted}</span> /${price?.cycleText}`;
		}

		return priceFormatted;
	}
	<template>
		<div class={{joinClasses (array "account-billing-summary-row" this.rowClass)}}>
			<CommonUiIconComponent @name={{@model.icon}} @class="summary__icon" />
			<div class="summary__title">{{@model.name}}</div>
			<div class="summary__price">
				{{#if this.priceFormatted}}
					{{{this.priceFormatted}}}
				{{else}}
					<div class="free-tag"></div>
				{{/if}}
			</div>
		</div>
	</template>
}
